import lisaApi from 'api/lisaApi'
import { Nullable } from 'types'

export const setAuthHeader = (token: Nullable<string>) => {
  lisaApi.defaults.headers.common.Authorization = token
    ? 'Bearer ' + token
    : ''
}
